// extracted by mini-css-extract-plugin
module.exports = {"root":"_4bc6b6","nonEmpty":"_9053a1","active":"_931552","dark":"_129ed0","light":"_327fd0","icon":"_ab2ee1","basket":"_622c12","show":"_2b0f99"};